var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('rect',{attrs:{"x":_vm.x - _vm.padding,"y":_vm.offsetY + 3 - _vm.padding,"width":_vm.width + _vm.padding*2,"height":_vm.width + _vm.padding*2,"fill":_vm.fill,"fill-opacity":"0.8"}}),_c('text',{attrs:{"x":_vm.x+_vm.padding,"y":_vm.offsetY + _vm.width,"font-size":_vm.width,"font-weight":"bold","fill":"black"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }